var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('SidbearSettingsGroup',{attrs:{"title":"Compare Slider","active":""}},[_c('b-form-group',{staticClass:"mb-4"},[_c('b-checkbox',{model:{value:(_vm.section.options.content.compare.vertical),callback:function ($$v) {_vm.$set(_vm.section.options.content.compare, "vertical", $$v)},expression:"section.options.content.compare.vertical"}},[_vm._v(" Vertical ")])],1),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}--compare-slider`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Image Size","var":"--width","measurement":"width"}})],1),_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--container`,"rule-name":"justify-content","label":"Alignment"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Before Image"}},[_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider .after-image`,"title":"","rule-name":"content"}}),_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider .after-image`,"rule-name":"filter"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"After Image"}},[_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider .before-image`,"title":"","rule-name":"content"}}),_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider .before-image`,"rule-name":"filter"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Handler Button","group":""}},[_c('b-form-group',{staticClass:"mb-0"},[_c('sid-checkbox',{attrs:{"unchecked-value":"flex","value":"none","rule-name":"display","sid":`.--${_vm.section.sid}--handler-button`}},[_vm._v(" Hide Button ")])],1),_c('b-form-group',[_c('icon-select',{model:{value:(_vm.section.options.content.compare.handleIcon),callback:function ($$v) {_vm.$set(_vm.section.options.content.compare, "handleIcon", $$v)},expression:"section.options.content.compare.handleIcon"}})],1),_c('SidbearSettingsGroup',{staticClass:"mb-0",attrs:{"title":"Layout & Style","button-class":"ml-[4px]"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"mb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--handler-icon`}})],1)]),_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"width","sid":`.--${_vm.section.sid}--handler-button`}}),_c('sid-range-slider',{attrs:{"label":"Height","rule-name":"height","sid":`.--${_vm.section.sid}--handler-button`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--handler-button`}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"mb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--handler-icon`,"presudo":":hover"}})],1)]),_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"width","presudo":":hover","sid":`.--${_vm.section.sid}--handler-button`}}),_c('sid-range-slider',{attrs:{"label":"Height","rule-name":"height","presudo":":hover","sid":`.--${_vm.section.sid}--handler-button`}}),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"presudo":":hover"}})],1)],2)],1),_c('SidbearSettingsGroup',{staticClass:"mb-0",attrs:{"title":"Border & Radius","button-class":"ml-[4px]"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"label":"Border Width","rule-name":"border","angles":[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--handler-button`,"rule-name":"border","angles":[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--handler-button`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--handler-button`,"rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]}})],1)],2)],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Handler Line"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"--handler-size","sid":`.--${_vm.section.sid}--handler`}})],1),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--handler`}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Width","rule-name":"--handler-size","sid":`.--${_vm.section.sid}--handler`,"presudo":":hover"}})],1),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--handler`,"presudo":":hover"}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider`,"rule-name":"box-shadow"}})],1),_c('template',{slot:"Hover"},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--compare-slider`,"presudo":":hover","rule-name":"box-shadow"}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--container`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--container`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--container`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--container`,"rule-name":"border","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--container`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--container`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--container`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--container`,"rule-name":"border","presudo":":hover","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--container`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }